export function paymentTicketReceiverListGet(page) {
	return {
    type: 'PAYMENT_TICKET_RECEIVER_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function paymentTicketSenderListGet(page) {
	return {
    type: 'PAYMENT_TICKET_SENDER_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function paymentTicketSendCheck(pic, callback) {
	return {
    type: 'PAYMENT_TICKET_SEND_CHECK',
		payload: {
			pic: pic,
		},
		callback: callback,
	}
}

export function paymentTicketSend(pic, paymentTicketId, callback) {
	return {
    type: 'PAYMENT_TICKET_SEND',
		payload: {
			pic: pic,
			paymentTicketId: paymentTicketId,
		},
		callback: callback,
	}
}
